export { CompanyDetailsWebPage, CompanyDetailsAddress } from './companyDetailsWebPage'
